(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reset-share-link')) {
    customElements.define('reset-share-link', class extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('[data-share-button]');
      this.status = this.querySelector('[data-share-status]');
      this.button?.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
      window.clearTimeout(this.statusTimer);
    }

    async getShareUrl() {
      if (this.dataset.shareMode !== 'cart') return window.location.href;

      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error('Cart request failed');

      const cart = await response.json();
      if (!cart.items.length) throw new Error('Cart is empty');

      const quantities = new Map();
      cart.items.forEach((item) => {
        quantities.set(item.variant_id, (quantities.get(item.variant_id) || 0) + item.quantity);
      });

      const cartPath = Array.from(quantities)
        .map(([variantId, quantity]) => `${variantId}:${quantity}`)
        .join(',');

      const cartUrl = new URL(`${root}cart/${cartPath}`, window.location.origin);
      cartUrl.searchParams.set('storefront', 'true');
      return cartUrl.href;
    }

    async copyUrl(url) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
        return;
      }

      const field = document.createElement('textarea');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      document.execCommand('copy');
      field.remove();
    }

    showStatus(message) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.classList.add('is-visible');
      window.clearTimeout(this.statusTimer);
      this.statusTimer = window.setTimeout(() => {
        this.status.classList.remove('is-visible');
      }, 2600);
    }

    async handleClick() {
      if (!this.button) return;
      this.button.disabled = true;

      try {
        const url = await this.getShareUrl();
        const shareData = {
          title: this.dataset.shareTitle || document.title,
          text: this.dataset.shareText || '',
          url,
        };

        if (navigator.share) {
          try {
            await navigator.share(shareData);
            this.showStatus(this.dataset.shareSuccess || 'Shared');
            return;
          } catch (error) {
            if (error?.name === 'AbortError') return;
          }
        }

        await this.copyUrl(url);
        this.showStatus(this.dataset.shareCopied || 'Link copied');
      } catch (error) {
        if (error?.name !== 'AbortError') {
          this.showStatus(this.dataset.shareError || 'Unable to share right now');
        }
      } finally {
        this.button.disabled = false;
      }
    }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["reset-volume-pricing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reset-tier-price')) {
    customElements.define(
      'reset-tier-price',
      class extends HTMLElement {
        connectedCallback() {
          this.root =
            this.closest('[id^="ProductInformation-"]') ||
            this.closest('product-information') ||
            this.closest('.shopify-section') ||
            document;
          this.summary = this.querySelector('[data-tier-summary]');
          this.variantPrices = this.getVariantPrices();
          this.tiers = [
            { minimum: 100, discount: Number(this.dataset.tier100Discount || 30) },
            { minimum: 50, discount: Number(this.dataset.tier50Discount || 20) },
            { minimum: 10, discount: Number(this.dataset.tier10Discount || 10) },
          ];
          this.handleInteraction = this.handleInteraction.bind(this);
          this.root.addEventListener('click', this.handleInteraction);
          this.root.addEventListener('input', this.handleInteraction);
          this.root.addEventListener('change', this.handleInteraction);
          this.update();
        }

        disconnectedCallback() {
          this.root?.removeEventListener('click', this.handleInteraction);
          this.root?.removeEventListener('input', this.handleInteraction);
          this.root?.removeEventListener('change', this.handleInteraction);
          window.clearTimeout(this.updateTimer);
        }

        getVariantPrices() {
          try {
            return JSON.parse(this.querySelector('[data-variant-prices]')?.textContent || '{}');
          } catch (error) {
            return {};
          }
        }

        handleInteraction() {
          window.clearTimeout(this.updateTimer);
          this.updateTimer = window.setTimeout(() => this.update(), 120);
        }

        getVariantId() {
          const formVariant = this.root.querySelector('form[action*="/cart/add"] input[name="id"]');
          const urlVariant = new URL(window.location.href).searchParams.get('variant');
          return String(formVariant?.value || urlVariant || Object.keys(this.variantPrices)[0] || '');
        }

        getQuantity() {
          const quantityInput = this.root.querySelector('input[name="quantity"]');
          return Math.max(1, Number.parseInt(quantityInput?.value || '1', 10));
        }

        getPriceContainer() {
          return this.root.querySelector('product-price [ref="priceContainer"]') || null;
        }

        getTierPrice(basePrice, tier) {
          return Math.round(basePrice * (100 - tier.discount) / 100);
        }

        formatMoney(amountInCents) {
          const currency = window.Shopify?.currency?.active || 'USD';
          return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency,
          }).format(amountInCents / 100);
        }

        restorePrice() {
          if (this.activePriceContainer?.dataset.resetBaseHtml) {
            this.activePriceContainer.innerHTML = this.activePriceContainer.dataset.resetBaseHtml;
            delete this.activePriceContainer.dataset.resetBaseHtml;
          }
          this.activePriceContainer = null;
        }

        updateTierTable(basePrice, activeTier) {
          this.querySelectorAll('[data-tier-minimum]').forEach((tierElement) => {
            const minimum = Number(tierElement.dataset.tierMinimum);
            const tier = this.tiers.find((item) => item.minimum === minimum);
            const priceElement = tierElement.querySelector('[data-tier-unit-price]');
            if (!tier || !priceElement) return;
            priceElement.textContent =
              `${this.formatMoney(this.getTierPrice(basePrice, tier))} / ${this.dataset.vialLabel || 'vial'}`;
            tierElement.classList.toggle('is-active', activeTier?.minimum === minimum);
          });
        }

        update() {
          this.restorePrice();

          const basePrice = Number(this.variantPrices[this.getVariantId()]);
          if (!Number.isFinite(basePrice)) return;

          const quantity = this.getQuantity();
          const tier = this.tiers.find((item) => quantity >= item.minimum);
          this.updateTierTable(basePrice, tier);
          this.summary.textContent = '';

          if (!tier) return;

          const tierPrice = this.getTierPrice(basePrice, tier);
          const priceContainer = this.getPriceContainer();
          const price = priceContainer?.querySelector('.price');
          if (priceContainer && price) {
            priceContainer.dataset.resetBaseHtml = priceContainer.innerHTML;
            this.activePriceContainer = priceContainer;
            price.textContent = this.formatMoney(tierPrice);
          }

          const eachLabel = this.dataset.eachLabel || 'each';
          const totalLabel = this.dataset.totalLabel || 'total';
          const vialsLabel = this.dataset.vialsLabel || 'vials';
          this.summary.textContent =
            `${quantity} ${vialsLabel} x ${this.formatMoney(tierPrice)} ${eachLabel} = ` +
            `${this.formatMoney(quantity * tierPrice)} ${totalLabel}`;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
